import { defaultTo } from 'ramda';
import { ICheckoutDetail } from '../../../redux/reducers/checkoutInfo/types/checkoutDetail';
import { IWriteOffInfoSchema } from '../../../repositories/monolith-python/entities/WriteOffInfoSchema';

export function mapDetails(writeOffInfo?: IWriteOffInfoSchema | null): Array<ICheckoutDetail> {
  const parts = writeOffInfo?.parts || [];

  return parts.map(
    ({ amount, description, periodInDays, discountAmount, discountDescription = null, note = null }) => ({
      name: description,
      price: amount,
      periodInDays,
      discountDescription,
      note,
      discount: defaultTo(0, discountAmount),
    }),
  );
}
